// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#other-office-connection-edit[data-v-77cad74d]{max-width:660px;margin-left:auto;margin-right:auto}#other-office-connection-edit .cancel-btn[data-v-77cad74d],#other-office-connection-edit .update-btn[data-v-77cad74d]{width:120px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
